import React from 'react';

const BuyMeACoffee: React.FC = () => (
  <a href="https://buymeacoffee.com/josueagbekodo" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
    <img
      src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
      alt="Buy Me A Coffee"
      style={{ height: 34, width: 'auto' }}
    />
  </a>
);

export default BuyMeACoffee;
